import Text from "@ds/components/Text";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import color from "@definitions/mui/color";
import { fontFamSecondary } from "@definitions/mui/custom";
import SwipeableMenu from "@containers/Policy/components/SwipeableMenu";
import useActions from "./hooks/useActions";
import MenuList from "../MenuList";

export type ContentMenuScrollProps = React.PropsWithChildren<{
  title: string;
  tableOfContents: string[];
}>;

const ContentMenuScroll: React.FC<ContentMenuScrollProps> = ({
  title,
  children,
  tableOfContents
}) => {
  const {
    menuRef,
    isDisplayMenu,
    selected,
    isOpen,
    onOpen,
    onClose,
    onClickMenuSwipeable,
    isMobile,
    scrollToId
  } = useActions({ tableOfContents });

  const menuOptions = isDisplayMenu && isMobile && (
    <Box
      position="fixed"
      top="56px"
      left={0}
      right={0}
      bgcolor="white"
      zIndex={1}
      boxShadow="0px 6px 12px rgba(46, 67, 77, 0.1)"
    >
      <Box p="10px">
        <SwipeableMenu
          selected={selected ?? ''}
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          onChange={onClickMenuSwipeable}
          tableOfContents={tableOfContents}
        />
      </Box>
    </Box>
  );

  return (
    <Box
      bgcolor={color.white}
      width="100%"
      position="relative"
      px={isMobile ? 2 : 0}
      id="content-scroll-wrapper"
    >
      {menuOptions}
      <Container maxWidth="lg" disableGutters ref={menuRef} sx={{
        paddingY: 2
      }}>
        {!isMobile && (
          <Box
            pt={isMobile ? 2 : 5}
            pb={isMobile ? 4 : 5}
            bgcolor={color.white}
            position={isMobile ? "static" : "sticky"}
            top="calc(70px + 40px)"
            width="100%"
            zIndex={1}
          >
            <Text
              color="general-main"
              variant="h2"
              weight="700"
              sx={{ fontSize: isMobile ? 24 : 40, lineHeight: "54px" }}
            >
              {title}
            </Text>
          </Box>
        )}
        <Box display={isMobile ? "block" : "flex"} pb={isMobile ? 0 : 10}>
          {!isMobile && (
            <MenuList tableOfContents={tableOfContents} onScroll={(e) => scrollToId(e)} />
          )}
          <Box
            width={isMobile ? "100%" : "calc(100% - 300px)"}
            sx={{
              color: color.general.main,
              fontFamily: fontFamSecondary,
              textAlign: "justify",
            }}
          >
            {children}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ContentMenuScroll;
